import { StyleSheet } from 'react-native';

import { useLocale } from '../../hooks/useLocale';
import { useStaticTranslation } from '../../services/staticTranslations';
import { Languages } from '../../util/enums';

const LogoWithNameWhiteImage = ({ style }) => {
  const useFrench = useLocale() === Languages.french;
  const oneX = useFrench
    ? require('./logo-with-name-white-fr.png')
    : require('./logo-with-name-white.png');
  const twoX = useFrench
    ? require('./logo-with-name-white-fr@2x.png')
    : require('./logo-with-name-white@2x.png');
  const dimensions = useFrench
    ? { height: 64, width: 266 }
    : { height: 65, width: 255 };
  return (
    <img
      src={twoX}
      style={StyleSheet.flatten([dimensions, style])}
      srcSet={`${oneX}, ${twoX} 2x`}
      alt={useStaticTranslation('BreathingRoom')}
    />
  );
};

export { LogoWithNameWhiteImage };
